import { shutdown } from '@intercom/messenger-js-sdk';

/**
 * Termine la session du messenger et jette ses cookies. À appeler sur **tout changement
 * d'identité dans l'onglet** — sign-out et sortie d'impersonation : sans ça, l'identité
 * suivante rouvre le widget sur la conversation de la précédente.
 *
 * Le garde n'est pas cosmétique : hors production le messenger n'est jamais booté
 * (`resolveIntercomAppId`), `window.Intercom` n'existe donc pas et le SDK se contenterait de
 * logger un warn à chaque appel. Et rien ne remonte à l'appelant : ni une déconnexion ni une
 * sortie d'impersonation ne doit échouer à cause du chat.
 */
export function shutdownIntercomMessenger() {
    try {
        if (typeof window.Intercom === 'function') {
            shutdown();
        }
    } catch (error) {
        console.error('Intercom shutdown failed', error);
    }
}
